import { render } from "./DetailTemplate.vue?vue&type=template&id=07201da0"
import script from "./DetailTemplate.vue?vue&type=script&lang=js"
export * from "./DetailTemplate.vue?vue&type=script&lang=js"

import "./DetailTemplate.vue?vue&type=style&index=0&id=07201da0&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__